
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","data-name":"oeamtc-icon__connected-car","width":"16","height":"16"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8 1.7a4.79 4.79 0 013.45 1.46l.85-.85a6 6 0 00-8.58 0l.85.85A4.77 4.77 0 018 1.7zM10.6 4a3.6 3.6 0 00-5.19 0l.85.84A2.44 2.44 0 018 4.1a2.38 2.38 0 011.75.76zm2.23 5.46l-.54-1.86C12 6.6 11.1 6 9.64 6H6.36a2.61 2.61 0 00-2.65 1.61l-.54 1.86A1.9 1.9 0 002 11.22v3.28a1 1 0 002 0V14h8v.5a1 1 0 002 0v-3.27a1.91 1.91 0 00-1.17-1.76zm-9 2.43a.6.6 0 11.6-.6.6.6 0 01-.63.61zm5.7.1h-3a.5.5 0 010-1h3a.5.5 0 010 1zm1.84-2.6A21.59 21.59 0 008 9.24a21.59 21.59 0 00-3.34.16h-.1a.22.22 0 01-.15-.27l.36-1.24A1.57 1.57 0 016.36 7h3.28a1.57 1.57 0 011.59.89l.36 1.24a.17.17 0 010 .1.21.21 0 01-.25.17zm.86 2.5a.6.6 0 11.6-.6.6.6 0 01-.63.61z"}})])
          )
        }
      }
    